'use client';

import GlobalContext from './global-context';
import { useOverwolfApi } from '../hooks/use-overwolf-api';
import { useIframeNavigationBridge } from '../hooks/use-iframe-navigation-bridge';

interface Props {
  children: React.ReactNode;
  config: any;
}

// -----------------------------------------------------------------------------
const GlobalContextProvider = (props: Props): JSX.Element => {
  const { config, children } = props;
  useOverwolfApi();
  useIframeNavigationBridge();
  return (
    <GlobalContext.Provider value={{ config }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
